
export interface IMyLibraryState {
  section: string | null
}

export const UpdateMyLibraryAction: string = "update-my-library-action";